// Invoice내역 > 사용내역서
import dateFormatType from '@/constants/dateFormatType';
import { invoiceUseHistoryFieldPack, invoiceUseHistoryLocalePack, } from '@/constants/salesFieldPack';
import { beforeDays } from '@/utils/time';
import { format } from 'date-fns';
import AbsSales from './AbsSales';
export default class InvoiceUseHistory extends AbsSales {
    resourceType = 'hub';
    dateType = 'daily';
    date = [];
    graphName = '그래프';
    graphSubTitle = '허브 바로머니 일별 통계';
    graphCaptureName = '매출_허브_바로머니_일별';
    excelFileName = '매출_허브_바로머니_일별';
    excelSheetName = 'Sheet1';
    excelCellWidth = [
        10,
        25,
        12,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
    ];
    excelHeaderData = [
        [],
    ];
    excelMergeData = [];
    pageHeaderData = [
        {
            title: invoiceUseHistoryLocalePack.dataCheck,
            value: invoiceUseHistoryFieldPack.dataCheck,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.status,
            value: invoiceUseHistoryFieldPack.status,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.receiptDate,
            value: invoiceUseHistoryFieldPack.receiptDate,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.receiptTime,
            value: invoiceUseHistoryFieldPack.receiptTime,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.completionTime,
            value: invoiceUseHistoryFieldPack.completionTime,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.cancelTime,
            value: invoiceUseHistoryFieldPack.cancelTime,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.franchiseeCode,
            value: invoiceUseHistoryFieldPack.franchiseeCode,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.orderHubName,
            value: invoiceUseHistoryFieldPack.orderHubName,
            align: 'center',
            cellAlign: 'ta-c',
            width: 200,
        },
        {
            title: invoiceUseHistoryLocalePack.distance,
            value: invoiceUseHistoryFieldPack.distance,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.deliveryCommission,
            value: invoiceUseHistoryFieldPack.deliveryCommission,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.deliveryCommissionVat,
            value: invoiceUseHistoryFieldPack.deliveryCommissionVat,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.supportFund,
            value: invoiceUseHistoryFieldPack.supportFund,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.supportFundVat,
            value: invoiceUseHistoryFieldPack.supportFundVat,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.deliveryFee,
            value: invoiceUseHistoryFieldPack.deliveryFee,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.vat,
            value: invoiceUseHistoryFieldPack.vat,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.vatIncluded,
            value: invoiceUseHistoryFieldPack.vatIncluded,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.receiptNumber,
            value: invoiceUseHistoryFieldPack.receiptNumber,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.posReceiptNumber,
            value: invoiceUseHistoryFieldPack.posReceiptNumber,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.brandPosNo,
            value: invoiceUseHistoryFieldPack.brandPosNo,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.executorCode,
            value: invoiceUseHistoryFieldPack.executorCode,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.executorName,
            value: invoiceUseHistoryFieldPack.executorName,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceUseHistoryLocalePack.cash,
            value: invoiceUseHistoryFieldPack.cash,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.card,
            value: invoiceUseHistoryFieldPack.card,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.prePayment,
            value: invoiceUseHistoryFieldPack.prePayment,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.productFee,
            value: invoiceUseHistoryFieldPack.productFee,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.serviceFee,
            value: invoiceUseHistoryFieldPack.serviceFee,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.productAdditionFee,
            value: invoiceUseHistoryFieldPack.productAdditionFee,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.additionalFee,
            value: invoiceUseHistoryFieldPack.additionalFee,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.additionalAdditionFee,
            value: invoiceUseHistoryFieldPack.additionalAdditionFee,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
        {
            title: invoiceUseHistoryLocalePack.areaAdditionFee,
            value: invoiceUseHistoryFieldPack.areaAdditionFee,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            isTotal: 'sum',
        },
    ];
    isGraphConfig = false;
    // eslint-disable-next-line class-methods-use-this
    makeGraphConfig() { }
    /**
     * 초기화 날짜 생성
     * @returns 초기화 날짜
     */
    initDate() {
        this.date = [
            format(beforeDays(new Date(), 1), dateFormatType.DATE),
            format(new Date(), dateFormatType.DATE),
        ];
    }
}
